import {IStringTree} from '@entities/common/interfaces';
import {mapObject} from '@utils/map-object.function';

export function deepMap<R, K, T extends IStringTree<K>>(
  obj: T,
  fn: (val: K | IStringTree<K>) => R
): IStringTree<R> {
  const deepMapper = (val: K | IStringTree<K>) => {
    if (val !== null && typeof val === 'object') {
      return deepMap(val as IStringTree<K>, fn);
    }
    return fn(val);
  };

  if (Array.isArray(obj)) {
    return obj.map(deepMapper) as unknown as IStringTree<R>;
  }

  return mapObject(obj, deepMapper) as IStringTree<R>;
}
